module.exports = __webpack_public_path__ + "989cde42ed08cf1c25438178830e763c.png";